import { useState } from "react";
import { useForm } from "react-hook-form";

import Select from "@/components/select/Select";
import Button from "@/components/Button";
import Input from "@/components/input/Input";

import CourseSelection from "./CourseSelection";
import LecturesSelection from "./LecturesSelection";
import useCreateOffer from "./../hooks/useCreateOffer";

import { Chip } from "@nextui-org/react";
import { useSchoolLevelOptions } from "../../../../hooks/useSchoolLevelOptions";

function CreateForm() {
    const [courseId, setCourseId] = useState(null);
    const [lecturesIds, setLecturesIds] = useState([]);

    const { createOffer, isCreating, error: ApiError } = useCreateOffer();

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        watch,
        getValues,
    } = useForm();

    const selectedSchoolLevel = getValues("school_level");
    const { isSchoolLevelOptionsLoading, schoolLevelOptions, gradesOptions } = useSchoolLevelOptions(selectedSchoolLevel);
    const formValue = getValues();

    function onSubmit(data) {
        if (lecturesIds.length)
            createOffer(
                { ...data, lecture_ids: lecturesIds.filter(Boolean) },
                {
                    onSuccess: () => {
                        reset();
                        setLecturesIds([]);
                        setCourseId(null);
                    },
                }
            );
    }

    const handleCloseChip = (id) => {
        const updatedIds = lecturesIds.filter((lectureId) => lectureId !== id);
        const filteredIds = updatedIds.filter(Boolean); // Filter out null values
        setLecturesIds(filteredIds);
    };

    return (
        <form
            onSubmit={handleSubmit(onSubmit)}
            className="flex flex-col items-center justify-center gap-5 py-10"
        >
            <Select
                name="school_level"
                label="المستوى الدراسي*"
                disabled={isCreating}
                error={
                    errors?.school_level?.message ||
                    ApiError?.response?.data?.errors?.school_level?.[0]
                }
                isOptionsLoading={isSchoolLevelOptionsLoading}
                options={schoolLevelOptions}
                size="halfWidth"
                watch={watch}
                register={register("school_level", {
                    required: "يجب اختيار السنة الدراسية",
                })}
            />
            <Select
                label="السنة الدراسية"
                disabled={isCreating}
                error={
                    errors?.grade?.message ||
                    ApiError?.response?.data?.errors?.grade?.[0]
                }
                isOptionsLoading={isSchoolLevelOptionsLoading}
                options={gradesOptions}
                name="grade"
                size="halfWidth"
                watch={watch}
                register={register("grade", {
                    required: "يجب اختيار السنة الدراسية",
                })}
            />

            <Input
                label="أسم العرض"
                type="text"
                name="name"
                disabled={isCreating}
                size="halfWidth"
                error={
                    errors?.name?.message ||
                    ApiError?.response?.data?.errors?.name?.[0]
                }
                register={register("name", {
                    required: "يجب ادخال اسم العرض",
                })}
            />

            <Input
                label="الوصف"
                type="text"
                name="brief"
                size="halfWidth"
                disabled={isCreating}
                error={
                    errors?.brief?.message ||
                    ApiError?.response?.data?.errors?.brief?.[0]
                }
                register={register("brief", {
                    required: "يجب ادخال وصف للعرض",
                })}
            />

            <Input
                label="السعر"
                name="price"
                type="number"
                disabled={isCreating}
                error={
                    errors?.price?.message ||
                    ApiError?.response?.data?.errors?.price?.[0]
                }
                size="halfWidth"
                register={register("price", {
                    required: "يجب ادخال السعر",
                })}
            />

            {formValue.grade && (
                <CourseSelection
                    grade={formValue.grade}
                    setCourseId={setCourseId}
                />
            )}

            {courseId && (
                <LecturesSelection
                    courseId={courseId}
                    setLecturesIds={setLecturesIds}
                    lecturesIds={lecturesIds}
                />
            )}

            {lecturesIds.length ? (
                <div className="flex flex-col gap-3 py-10">
                    <p className="text-lg font-semibold text-primary-color-primary">
                        المحاضرات التي تم اختيارها داخل العرض:
                    </p>
                    <div>
                        {lecturesIds.map(
                            (id) =>
                                id !== null && (
                                    <Chip
                                        key={id}
                                        onClose={() => handleCloseChip(id)}
                                        variant="bordered"
                                        className="mx-2 text-lg font-semibold text-blue-color-primary"
                                    >
                                        {id}
                                    </Chip>
                                )
                        )}
                    </div>
                </div>
            ) : null}
            {lecturesIds.length ? (
                <Button type="primary" disabled={isCreating}>
                    إنشاء العرض
                </Button>
            ) : null}
        </form>
    );
}

export default CreateForm;
